/* eslint-disable react/jsx-pascal-case */
import Footer from '../components/common/footer';
import Wallet_modal from '../components/common/modal/wallet_modal';
import BidsModal from '../components/common/modal/bidsModal';
import BuyModal from '../components/common/modal/buyModal';
import { useRouter } from 'next/router';
import Header01 from '../components/common/header/Header01';
import Header02 from '../components/common/header/Header02';
import Header03 from '../components/common/header/Header03';
import Header04 from '../components/common/header/Header04';
import Proparties_modal from '@/components/common/modal/proparties_modal';
import { useTheme } from 'next-themes';
import { useEffect } from 'react';
import Toast from '@/components/common/toast/Toast';

export default function Layout({ children }) {
  const route = useRouter();
  // header start
  let header;
  if (
    route.asPath === '/home/home_3'
    || route.asPath === '/home/home_9'
    || route.asPath === '/maintenance'
    || route.asPath === '/home/home_12'
  ) {
    header = <Header02 />;
  } else if (route.asPath === '/platform_status') {
    header = <Header03 />;
  } else if (route.asPath === '/home/home_8') {
    header = <Header04 />;
  } else {
    header = <Header01 />;
  }
  // header end
  return (
    <>
      {header}
      <Wallet_modal />
      <BidsModal />
      <BuyModal />
      <Proparties_modal />
      <main>{children}</main>
      <Footer />
    </>
  );
}
